/* eslint-disable react/display-name */
import * as React from 'react';

const ChevronDown = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <g>
      <path
        d="M8,9.72l5.84-6.3a1.23,1.23,0,0,1,1.72-.07l.06.07a1.4,1.4,0,0,1,0,1.92L8.91,12.58a1.26,1.26,0,0,1-1.75.07l-.07-.07L.38,5.34a1.4,1.4,0,0,1,0-1.92,1.21,1.21,0,0,1,1.71-.07l.07.07Z"
        style={{ fill: 'inherit' }}
      />
    </g>
  </svg>
);

export default ChevronDown;
